<script lang="ts" setup></script>
<template>
    <div class="mentions-legales-page">
        <h1 class="text-5xl text-center font-semibold">Mentions légales</h1>
        <div class="mentions-legales-page__info text-base">
            <p>
                <strong>Dénomination sociale</strong> : Homeys Structure : SAS
                SIRET : 839 582 335 00015
            </p>
            <p>
                <strong>Adresse</strong> : 30 RUE MONSIEUR LE PRINCE 75006 PARIS
            </p>
            <p><strong>Contact</strong> : contact@homeys.io</p>
            <p>
                <strong>Directeur de la publication</strong> : Henri de NOBLENS
            </p>
            <p><strong>Hébergement</strong> : OVH SAS, Roubaix</p>
            <p><strong>Exploitation</strong> : HOMEYS</p>
        </div>
        <p class="text-base">
            L'objectif de ce site est de présenter le programme WattWatchers et
            de permettre la récupération des informations liées aux travaux. La
            présentation originale du site, l'identité visuelle, le nom de
            domaine et la marque "Homeys" sont la propriété de Homeys et sont
            notamment protégés par le droit d'auteur et des droits de propriété
            industrielle. Enfin, Homeys se réserve le droit de poursuivre tout
            acte de contrefaçon de ses droits de propriété industrielle ou de
            droit d'auteur.
        </p>
    </div>
</template>

<style scoped>
.mentions-legales-page {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 3rem;

    flex: 1;

    /* Sur mobile */
    @media (--small-viewport) {
        max-width: 24.5rem !important;
        padding: 2rem 0.5rem;
    }

    @media (--medium-viewport) {
        max-width: 40rem !important;
        padding: 2rem 0.5rem;

        gap: 7.5rem;
    }

    /* Sur tablette */
    @media (--large-viewport) {
        max-width: 54rem;
    }
}
.mentions-legales-page__info {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}
</style>
